import { useCallback } from 'react';
import { useProject } from '../config/ProjectContext';
import { isFeatureAvailableInRegion } from '../config/regions';

/**
 * useRegionFeatureGate Hook
 *
 * Reads the currently selected data region from ProjectContext and returns a
 * predicate to check whether a given "Category A" feature is available in that
 * region (feature 021-china-account-access).
 *
 * Usage:
 *   const isFeatureAvailable = useRegionFeatureGate();
 *   if (isFeatureAvailable('deviceDefender')) { ... }
 *
 * Returns:
 *   (featureKey: string) => boolean
 */
export default function useRegionFeatureGate() {
  const { region } = useProject();

  return useCallback(
    (featureKey) => isFeatureAvailableInRegion(featureKey, region),
    [region],
  );
}
